import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import spaghetti from "assets/img/spaghetti.jpg";
import { Helmet } from 'react-helmet'
// @material-ui/icons
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

//import Ads5 from "../../Main/Sections/Ads5.js";
import Config from "../../../config.js"
import Axios from "axios";
import swal from 'sweetalert'

import styles from "assets/jss/material-kit-react/views/spaghetti.js";
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody } from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles(styles);

export default function LeaderBoardPage(props) {
    const classes = useStyles();
    const [data, setData] = React.useState(null);
    const [scroll, setScroll] = React.useState(false);
    const [hide, setHide] = React.useState(false);
    const [time, setTime] = React.useState(moment());
    const [prevData, setPrevData] = useState(null);
    const [isBlinking, setIsBlinking] = useState(false);
    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const shouldScroll = queryParams.has("scroll");
        setHide(queryParams.has("hide"))
        let interval = +queryParams.get("interval") || 20
        if (shouldScroll) {
            setScroll(true)
            // Auto-scroll functionality
            let direction = 1; // 1 for down, -1 for up
            const scrollAmount = 1;
            const scroll = () => {
                window.scrollBy(0, scrollAmount * direction);
                if ((window.scrollY >= (document.body.offsetHeight - window.innerHeight - 10)) && direction === 1) {
                    direction = -1; // Change direction to up
                } else if (window.scrollY <= 220 && direction === -1) {
                    direction = 1; // Change direction to down
                }
            };
            const scrollInterval = setInterval(scroll, interval);
            return () => clearInterval(scrollInterval);
        }
    }, []);
    useEffect(() => {
        if (prevData == null) {
            setPrevData(data)
            getData()
        } else {
            const t= setTimeout(() => {
                setPrevData(data)
                getData()
                setIsBlinking(true);
                const timer = setTimeout(() => {
                    setIsBlinking(false);
                }, 1000);
                return () => clearTimeout(timer);
            }, 20000)
            return () => clearTimeout(t);
        }
    }, [data]);

    const getData = () => {
        Axios.post(Config.api + "SCChallenge/LeaderBoard", {
            id: "1",
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setData(result.data.data)
                setTime(moment())
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                /*else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")*/
            })
    }
    const getChange = (teamName) => {
        if (!prevData || prevData.length === 0) return null;
        const prevIndex = prevData.findIndex(t => t.name === teamName);
        const newIndex = data.findIndex(t => t.name === teamName);
        if (prevIndex === -1 || newIndex === -1) return null;
        let prevScore = prevData[prevIndex].score
        let newScore = data[newIndex].score
        if (prevScore < newScore) return "#b2e8b1"
        else if (prevScore > newScore) return "#f8b6b6"
        else
            return "inherit";
    };

    const getRankChange = (teamName) => {
        if (!prevData || prevData.length === 0) return null;
        const prevIndex = prevData.findIndex(t => t.name === teamName);
        const newIndex = data.findIndex(t => t.name === teamName);
        if (prevIndex === -1 || newIndex === -1) return null;
        if (prevIndex > newIndex) return <ArrowUpwardIcon style={{ position:"absolute", right:"100px", color: "green" }} />;
        if (prevIndex < newIndex) return <ArrowDownwardIcon style={{ position:"absolute", right:"100px" ,color: "red" }} />;
        return null;
    };
    return (
        <div>
            <Helmet>
                { //<meta http-equiv="refresh" content="60" /> 
                }
            </Helmet>
            {(hide != true) ?
                <Header
                    color="transparent"
                    brand="Material Kit React"
                    rightLinks={<HeaderLinks />}
                    fixed
                    changeColorOnScroll={{
                        height: 200,
                        color: "white"
                    }}
                    {...rest}
                /> : <></>
            }


<Parallax small filter image={require("assets/img/bg5.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={spaghetti} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>جدول رده بندی مسابقات کد نویسی مبهم</h3>

                                    </div>
                                </div>
                                <br />
                                <br />

                            </GridItem>
                        </GridContainer>

                    </div>
                </div>
                <GridContainer justify="center" className={classes.box}>
                    <GridItem xs={10} sm={10} md={10}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>
                                <Typography variant="caption" display="block" gutterBottom>
                                    به روز رسانی در {time.format("HH:mm:ss")}
                                </Typography>
                                <br />
                                <div className={classes.codejam}>

                                    <TableContainer >
                                        <Table aria-label="collapsible table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell align="center">نام تیم</TableCell>
                                                    <TableCell align="center">امتیاز</TableCell>
                                                    <TableCell align="center">زمان</TableCell>
                                                    <TableCell align="center">امتیاز کد</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{backgroundColor: isBlinking?"#fafafc":"white" }}>
                                                {data && data.map((row, index) => {
                                                    let color = getChange(row.name)
                                                   
                                                    return <TableRow style={{ backgroundColor: color}}  className={classes.RightToLeft} key={row.name}>
                                                        <TableCell className={classes.RightToLeft} component="th" scope="row">
                                                        {getRankChange(row.name)} {index + 1} 

                                                        </TableCell>
                                                        <TableCell align="center">{row.name}</TableCell>
                                                        <TableCell align="center" >
                                                            {row.score}
                                                        </TableCell>

                                                        <TableCell align="center">{row.time}</TableCell>
                                                        <TableCell align="center">{row.break == 0 ? "✓" : "X"}</TableCell>
                                                    </TableRow>
                                                })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </div>
                            </GridItem>
                            <GridItem xs={10} sm={10} md={4}>
                                {
                                    //<Ads5 />
                                }
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>

            </div>
            {(hide != true) ? <Footer /> : <></>
            }

        </div>
    );
}
